import { FC } from 'react';
import { Tooltip } from '../../components/ui/tooltip';
import { CertificateIcon } from '@phosphor-icons/react';
import {
  ICertificateStatus,
  CertificateState,
  getCertificateState,
  getCertificateDaysLeft,
} from '../../models/injury';
import styles from './CertificateBadge.module.scss';

interface CertificateBadgeProps {
  certificate: ICertificateStatus;
  size?: 'sm' | 'md';
}

const STATE_CLASS: Record<CertificateState, string> = {
  'valid': styles.valid,
  'expiring-soon': styles.expiringSoon,
  'expired': styles.expired,
  'missing': styles.missing,
};

const TOOLTIP_TITLE: Record<CertificateState, string> = {
  'valid': '',
  'expiring-soon': 'Certificato in scadenza',
  'expired': 'Certificato scaduto',
  'missing': 'Certificato mancante',
};

export const CertificateBadge: FC<CertificateBadgeProps> = ({
  certificate,
  size = 'md',
}) => {
  const state = getCertificateState(certificate.medicalCertificateExpiry);

  // Non mostrare il badge se il certificato è valido
  if (state === 'valid') return null;

  const iconSize = size === 'sm' ? 10 : 12;

  const label: string = (() => {
    switch (state) {
      case 'expiring-soon':
        return `CERT ${getCertificateDaysLeft(certificate.medicalCertificateExpiry!)}gg`;
      case 'expired':
        return 'CERT SCAD';
      case 'missing':
        return 'CERT mancante';
      default:
        return '';
    }
  })();

  const tooltipBody = certificate.medicalCertificateExpiry
    ? `Scadenza: ${new Date(certificate.medicalCertificateExpiry).toLocaleDateString('it-IT')}`
    : 'Nessuna data di scadenza registrata';

  const tooltipContent = (
    <div className={styles.tooltip}>
      <p className={styles.tooltipTitle}>{TOOLTIP_TITLE[state]}</p>
      <p className={styles.tooltipLine}>{tooltipBody}</p>
    </div>
  );

  return (
    <Tooltip content={tooltipContent}>
      <span className={[styles.badge, STATE_CLASS[state], styles[size]].join(' ')}>
        <CertificateIcon size={iconSize} weight="bold" />
        {label}
      </span>
    </Tooltip>
  );
};

export default CertificateBadge;
